<template>
    <div>
        <header class="bg-main pb-6 pt-6 mb-6">
            <div class="flex justify-between orc-vert-limit-header">
                <!-- Logo -->
                <router-link :to="{ path: 'home'}">
                    <div class="logo orc-strong">
                        ORCA
                    </div>
                </router-link>
            </div>
        </header>
        <div class="orc-vert-limit-header pt-12">
            <h1>Artikel 1 Algemeen</h1>

            <p class="pb-6">
                Dit intern reglement preciseert de algemene regels voor de goede werking van de vzw watersportclub Orca Bilzen, met ondernemingsnummer 0896.538.831, hierna de vereniging.
            </p>
            
            <p class="pb-6">
                Dit intern reglement is van toepassing in onverbrekelijke samenhang met de recentste versie van de statuten van de vereniging, zoals die op de Ondernemingsrechtbank werden gepubliceerd. In geval van discrepantie tussen statuten en intern reglement, zullen de statuten steeds voorrang hebben.
            </p>

            <p class="pb-6">
                Ieder lid van de verenging is geacht kennis te hebben genomen van dit intern reglement en zal zich houden aan de bepalingen van dit reglement. Door de aansluiting bij de vereniging aanvaarden alle leden de reglementen en gedragscodes van de vereniging en de sportfederatie waarbij de vereniging is aangesloten (met inbegrip van het tuchtreglement) en de bevoegdheid van deze sportfederatie. 
            </p>

            <h1>Artikel 2 Leden</h1>

            De vereniging bestaat, zoals in de statuten bepaald, uit verschillende soorten leden:

            <ol class="spaced p-10">
                <li>Werkende leden: maken deel uit van en hebben stemrecht op de algemene vergadering. De voorwaarden waaraan de werkende leden moeten voldoen worden bepaald in de statuten. Een lijst van werkende leden wordt bijgehouden op de zetel.</li>
                <li>Toegetreden leden: ondersteunen de doelstelling van de vereniging, doen actief aan sport in de vereniging en betalen het vereiste lidgeld.</li>
            </ol>

            <p class="pb-6">
            Hun rechten en plichten worden, in voorkomend geval, beschreven in de statuten van de vereniging. Alle leden verbinden zich tevens tot volgende afspraken:
            </p>

            <ol class="spaced p-10">
                <li>Ieder lid wordt gewezen op het bestaan van de statuten (<a class="text-primary" href="www.ejustice.just.fgov.be/tsv/tsvn.htm">www.ejustice.just.fgov.be/tsv/tsvn.htm</a>) en het intern reglement van de vereniging. Dit laatste kan ingekeken worden op <a class="text-primary" href="www.orcabilzen.be">www.orcabilzen.be</a>.</li>
                <li>Ieder lid verbindt zich ertoe om de statuten, het intern reglement en alle andere richtlijnen en gedragscodes van de vereniging te zullen naleven. Ieder lid zal tevens alle regels opgelegd door de sportfederatie waarbij de vereniging aangesloten is, naleven. Bij schending hiervan kan een tuchtsanctie opgelegd worden zoals hierna bepaald.</li>
                <li>Ieder lid vertoont steeds onberispelijk, verantwoord en sportief gedrag met respect voor de werking van de medewerkers, andere leden en materiaal van de vereniging.</li>
                <li>Ieder lid kan klachten, wensen of voorstellen indienen bij het bestuur van de vereniging. Het bestuur engageert zich ertoe om het vragende lid binnen een redelijke termijn van antwoord te voorzien.</li>
                <li>Ieder lid geeft zo snel mogelijk een wijziging van zijn gegevens door aan het bestuur van de vereniging.</li>
                <li>Ieder lid betaalt tijdig het lidgeld. </li>
            </ol>

            <h1>Artikel 3 Lidmaatschap</h1>

                <p class="pb-6">
                3.1. Inschrijving bij de vereniging gebeurt via <a class="text-primary" href="www.orcabilzen.be">www.orcabilzen.be</a> waarop de volgende gegevens zijn in te vullen: naam, voornaam, adres, geboortedatum, telefoonnummer en rijksregisternummer. Voor minderjarigen of personen onder bewind zal steeds een ouder of wettelijke vertegenwoordiger zijn/haar toestemming moeten verlenen alvorens de aansluiting gerealiseerd kan worden.
                </p>

                <p class="pb-6">
                De aansluitingsvoorwaarden worden omschreven in de statuten van de vereniging. De aanvaarding en het respecteren van de bepalingen van het intern reglement is één van deze essentiële voorwaarden. 
                </p>

                <p class="pb-6">
                Bij de inschrijving in de vereniging, aanvaardt het lid dat de nodige gegevens ook zullen worden doorgegeven aan de sportfederatie van desbetreffende tak waarbij de vereniging is aangesloten. Op die manier kan het lid aangesloten worden bij deze sportfederatie, teneinde de verzekering voor burgerlijke aansprakelijkheid en lichamelijke ongevallen ten gunste van het lid te kunnen garanderen.
                </p>

                <p class="pb-6">
                3.2. De jaarlijkse bijdrage van de leden wordt bepaald door het bestuursorgaan van de vereniging.
                Deze lidmaatschapsbijdrage is jaarlijks te betalen op rekeningnummer BE97 1030 3934 1349 binnen de 8 dagen na aanmelding om lid te zijn van de vereniging voor het lopende werkingsjaar (1 september tot en met 30 juni).
                </p>

                <p class="pb-6">
                Bij aansluiting tijdens het lopende werkingsjaar blijft de volledige bijdrage verschuldigd. 
                </p>

                <p class="pb-6">
                Deze bijdrage omvat het volgende: lidgeld + verzekering.
                </p>

                <p class="pb-6">
                3.3. Het lid kan op eenvoudig verzoek de vereniging verlaten.
                </p>

                <p class="pb-6">
                3.4. De ledenbijdrage wordt in geen enkel geval, ook niet in geval van vroegtijdige beëindiging van het lidmaatschap of overmacht in de meest ruime zin (o.a. ziekte, overheidsmaatregelen, weersomstandigheden, …), terugbetaald. Het bestuur behoudt zich het recht voor om uitzonderingen toe te staan.
                </p>


            <h1>Artikel 4 Structuur</h1>

            De structuur van de vereniging is als volgt samengesteld:

            <ol class="spaced p-10">
                <li>De algemene vergadering bestaat uit alle werkende leden en komt minstens éénmaal per jaar samen. Indien nodig kan er een bijzonder algemene vergadering bijeenkomen.</li>
                <li> Het bestuursorgaan bestaat uit voorzitter, ondervoorzitter, secretaris, penningmeester en 1 bestuurslid. Zij worden benoemd door de algemene vergadering voor onbepaalde duur. Het bestuursorgaan is bevoegd om alle handelingen van intern bestuur te verrichten die nodig zijn voor de verwezenlijking van het doel van de vereniging.</li>
                <li>Het dagelijks bestuur wordt waargenomen door de voorzitter.</li>
                <li>Alle bevoegdheden van deze organen worden bepaald door de statuten van de vereniging.</li>
            </ol>


            <h1>Artikel 5 Veilig en ethisch verantwoord sporten</h1>

            Een veilige en ethisch verantwoorde sportomgeving is essentieel voor alle leden om vrijuit en ongestoord te kunnen deelnemen aan de activiteiten. Onze sportvereniging engageert zich daarom tot het naleven van volgende punten:

            <ol class="spaced p-10">
                <li>Alle bestuurders en vrijwilligers worden beschermd door het afsluiten van de nodige verzekeringen</li>
                <li>Alle leden worden beschermd door de verzekering die inbegrepen is in de ledenbijdrage.</li>
                <li>Er wordt gestreefd naar een vereniging zonder discriminatie, agressie, pesten en/of seksueel grensoverschrijdend gedrag</li>
                <li>Fairplay en sportiviteit worden hoog in het vaandel gedragen</li>
                <li>Er wordt gewerkt aan een fysiek veilige omgeving waarin elk lid zich veilig kan bewegen</li>
                <li>Er heerst een open sfeer waarin iedereen zijn mening kan geven</li>
                <li>Er wordt op een gezonde en medisch verantwoorde manier aan sport gedaan.</li>
            </ol>

            Van alle leden en allen die betrokken zijn bij de verenging, ook van de supporters, wordt verwacht dat ze zich onberispelijk gedragen en hiermee een voorbeeld zijn voor alle anderen.

            <p class="pb-6">
            Als bijlage aan dit Intern Reglement worden volgende gedragscodes (zie <a class="text-primary" href="www.orcabilzen.be">www.orcabilzen.be</a>) gevoegd en maken er integraal deel van uit:
            </p>

            <ul class="spaced p-10">
                <li>Gedragscode voor sporters</li>
                <li>Panathlonverklaring</li>
            </ul>

            <p class="pb-6">
                Deze gedragscode dient verplicht aanvaard en gerespecteerd te worden. Indien een lid deze verplichting niet respecteert, kan dit een grond tot uitsluiting of schorsing van het betrokken lid bij de sportvereniging zijn.
            </p>

            <h1>Artikel 6 Tucht en sancties</h1>

            <p class="pb-6">
            Wanneer een lid een bepaling van de statuten, het intern reglement, gedragscode of ander reglement geschonden heeft of zich ongepast gedragen heeft, kan een klacht aanhangig gemaakt worden conform de tuchtprocedure van de federatie waarbij de vereniging is aangesloten. Door de aansluiting bij de sportvereniging onderschrijft elk lid het tuchtreglement van de federatie en aanvaardt de toepassing ervan.
            </p>
            
            <p class="pb-6">
            Daarenboven kan het bestuur van de sportvereniging ter voorkoming van herhaling, om de orde of rust te herstellen of de veiligheid te waarborgen, ordemaatregelen (bv. schorsing deelname training of andere activiteiten) nemen. Dit betreft een bestuurlijke maatregel, geen tuchtsanctie.
            </p>

            <h1>Artikel 7 Sportspecifieke regels</h1>

            7.1. In het kader van een veilige beoefening van de sport, legt de sportclub volgende regels op aan de leden:

            <ul class="spaced pl-10 pt-6 pb-6">
                <li>De sportieve eindbeslissing over de deelname aan wedstrijden berust steeds bij de trainer.</li>
            </ul>

            7.2. Verder worden voor de goede werking van de vereniging volgende regels opgelegd aan de leden:
            
            <ul class="spaced pl-10 pt-6 pb-6">
                <li>Leden die aan wedstrijden deelnemen, dienen in de door het bestuur voorgeschreven kledij te verschijnen</li>
            </ul>

            <h1>Artikel 8 Sponsoring</h1>

            <p class="pb-6">
            De club kan contracten met sponsors aangaan. In het kader hiervan kunnen de leden communicatie toegestuurd krijgen waarop de sponsors vermeld staan. Daarnaast kan de leden ook gevraagd worden om wedstrijdkledij te dragen waarop het logo van de sponsor(s) is afgebeeld.
            </p>

            <h1>Artikel 9 Aansprakelijkheid</h1>


            <ol class="spaced pb-10 pl-10">
                <li>Ingeval van ongeval in de loop van een training, wedstrijd of andere activiteit van de vereniging, moet het lid dit zo snel mogelijk meedelen aan de betrokken verantwoordelijke. Indien het ongeval gedekt wordt door de verzekering van de vereniging, zal hiervan een aangifte gebeuren. Het lid is verzekerd volgens de polisvoorwaarden van deze verzekering en kan voor de niet gedekte of vergoede schade geen vergoeding vragen van de vereniging. De polisvoorwaarden zijn te raadplegen via het bestuur.  </li>
                <li>De vereniging is niet aansprakelijk voor de diefstal of de beschadiging van persoonlijke bezittingen van de leden, ook niet gedurende de uitoefening van de sport- of vrijetijdsactiviteiten. </li>
                <li>Ieder lid is aansprakelijk voor de door hem aan de eigendommen van de vereniging aangerichte schade. Elke geconstateerde schade wordt geacht veroorzaakt te zijn door hem of hen die de betreffende zaak het laatst heeft of hebben gebruikt, indien en voor zover het tegendeel niet door de betrokkene(n) wordt aangetoond.</li>
                <li>De vereniging kan niet aansprakelijk worden gehouden voor de inbreuken op de bepalingen van dit reglement, begaan door haar leden of door derden. </li>
            </ol>

            <h1>Artikel 10 Privacy</h1>

             <p class="pb-6">
                De vereniging verbindt zich ertoe de geldende wettelijke bepalingen rond de privacy van de leden te zullen respecteren. De persoonsgegevens van de leden worden overeenkomstig de privacyverklaring van de club behandeld. Deze privacyverklaring is te vinden op <a class="text-primary" href="www.orcabilzen.be">www.orcabilzen.be</a>.
            </p>
            
            <p class="pb-6"> 
                Elk lid stemt ermee in dat tijdens trainingen, wedstrijden en andere activiteiten van de vereniging foto’s en beeld opnames gemaakt worden waarop het lid afgebeeld wordt. Elk lid stemt er mee in dat deze foto’s en opnames door de vereniging gebruikt mogen worden voor weergave of publicatie op de website, folders, nieuwsbrief of sociale media van de sportvereniging, in welke vorm ook en al dan niet met vermelding van diens naam. Indien een lid dit niet wenst zal hij hiertoe uitdrukkelijk een verklaring afleggen tegenover het bestuur van de vereniging. 
            </p>

            <p class="pb-6">
                Het gebruik van de afbeelding levert geen financiële vergoeding op voor het lid. 
            </p>

            <h1>Artikel 11 Wijziging van het intern regelement</h1>

             <p class="pb-6">
                Dit intern reglement kan enkel gewijzigd worden op de wijze zoals in de statuten van de vereniging bepaald. Bij gebreke aan statuten of enige regeling hieromtrent, zal het reglement enkel aangepast kunnen worden door het bestuur van de vereniging.
            </p>

            <p class="pb-6">
                De laatste wijziging vond plaats op 1 december 2022.
            </p>    
        </div>
    </div>
</template>

<script>
    export default {
        name: "Terms",
    }
</script>

<style scoped>
    h1 {
        color: #409EFF;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    ol.spaced li {
        list-style: decimal;
        margin-bottom: 10px;
    }

    ul.spaced li {
        list-style: disc;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Terms.vue